/** Offline revision routing. No API calls, board writes, or production dispatch. */
export const REVISION_KINDS = ["script", "design", "assets", "motion", "timing", "production_method"];
export const REVISION_STEPS = ["script_review", "design", "assets", "alignment", "render", "timeline"];
export const DEFAULT_REVISION_MODEL = "~typesafe/jev-latest";
export const REVISION_STEP_LABELS = {
    script_review: "Review script", design: "Update design", assets: "Prepare assets",
    alignment: "Check audio alignment", render: "Render visuals", timeline: "Update Premiere timeline",
};
/** Code owns the dependency order; a classifier cannot invent tool actions. */
export function revisionSteps(kinds) {
    const routes = {
        script: ["script_review", "design", "alignment", "render", "timeline"],
        design: ["design", "render", "timeline"],
        assets: ["assets", "render", "timeline"],
        motion: ["render", "timeline"],
        timing: ["alignment", "render", "timeline"],
        production_method: ["design", "assets", "render", "timeline"],
    };
    const needed = new Set(kinds.flatMap((kind) => routes[kind]));
    return REVISION_STEPS.filter((step) => needed.has(step));
}
/**
 * Validate supplied typed classifier answers locally. This does NOT call Jev.
 * Thresholds are provisional and need evaluation before automated execution.
 * Confidence cannot verify audio alignment, renders, or actual job status.
 */
export function planRevision(value) {
    const invalid = () => ({ categories: [], suggestedSteps: [], status: "needs_review", reviewReasons: ["invalid-classification"], applied: false });
    const object = (v) => v !== null && typeof v === "object" && !Array.isArray(v);
    if (!object(value))
        return invalid();
    const scores = {};
    for (const key of [...REVISION_KINDS, "ambiguous", "no_change"]) {
        const answer = value[key];
        if (!object(answer) || answer.type !== "noul" || typeof answer.noul !== "number" || !Number.isFinite(answer.noul) || answer.noul < 0 || answer.noul > 1)
            return invalid();
        scores[key] = answer.noul;
    }
    const categories = REVISION_KINDS.filter((kind) => scores[kind] >= 0.85);
    const reasons = [];
    if (Object.values(scores).some((p) => p > 0.15 && p < 0.85))
        reasons.push("uncertain-classification");
    if (scores.ambiguous > 0.15)
        reasons.push("ambiguous-request");
    if (categories.length > 0 && scores.no_change > 0.15)
        reasons.push("conflicting-classification");
    if (categories.length === 0 && scores.no_change < 0.85)
        reasons.push("unrecognized-request");
    return {
        categories, suggestedSteps: revisionSteps(categories),
        status: reasons.length ? "needs_review" : categories.length ? "suggested" : "no_change",
        reviewReasons: reasons, applied: false,
    };
}
//# sourceMappingURL=revision-routing.js.map